"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isDefined = _interopRequireDefault(require("./isDefined"));

var getWrap = function getWrap(wrap) {
  return (0, _isDefined.default)(wrap) && (wrap ? "wrap" : "nowrap");
};

var _default = getWrap;
exports.default = _default;